module.exports = __webpack_public_path__ + "img/1ed2f750e9fb1f8253ec0cf43f41982d.png";